const ru = {
  meta: {
    siteName: "Nieder-Eschbacher Pflegedienst GmbH",
    titleSuffix: "Nieder-Eschbacher Pflegedienst",
    description:
      "Nieder-Eschbacher Pflegedienst GmbH, амбулаторная служба ухода во Франкфурте-на-Майне. Чуткий и профессиональный уход на дому: базовый уход, медицинский уход, помощь по хозяйству и круглосуточная связь.",
    pages: {
      home: "",
      about: "О нас",
      services: "Услуги",
      news: "Новости и вакансии",
      contact: "Контакты",
      imprint: "Выходные данные",
      privacy: "Политика конфиденциальности",
      notFound: "Страница не найдена",
    },
  },

  common: {
    call: "Позвонить",
    callNow: "Позвоните нам:",
    contactUs: "Связаться с нами",
    bookConsultation: "Записаться на консультацию",
    bookAppointment: "Записаться на приём",
    requestConsultation: "Запросить консультацию",
    aroundTheClock: "Круглосуточно:",
    reachable24h: "На связи круглосуточно",
    certifiedStaff: "Дипломированный персонал",
    whatsapp: "WhatsApp",
    whatsappText: "Здравствуйте, у меня вопрос о вашей службе ухода.",
    whatsappNote: "Пожалуйста, не отправляйте через WhatsApp данные о здоровье. В экстренных случаях позвоните нам.",
    symbolImage: "Иллюстративное фото",
    language: "Язык",
    changeLanguage: "Выбрать язык",
    skipToContent: "Перейти к содержанию",
    legalNote: "Этот перевод приведён для ознакомления. Юридическую силу имеет немецкая версия.",
  },

  header: {
    topbar24h: "На связи 24 часа",
    topbarConsult: "Бесплатная личная консультация",
    mainNav: "Основная навигация",
    mobileNav: "Мобильная навигация",
    openMenu: "Открыть меню",
    closeMenu: "Закрыть меню",
  },

  nav: {
    home: "Главная",
    about: "О нас",
    services: "Услуги",
    news: "Новости",
    contact: "Контакты",
    jobs: "Вакансии",
    imprint: "Выходные данные",
    privacy: "Конфиденциальность",
  },

  footer: {
    reach: "Как с нами связаться",
    fax: "Факс:",
    emergency: "Круглосуточный экстренный номер:",
    navigation: "Навигация",
    legal: "Правовая информация",
    area: "Франкфурт-на-Майне и окрестности (в первую очередь Нидер-Эшбах)",
    rights: "Все права защищены.",
  },

  floating: {
    whatsappLabel: "Написать нам в WhatsApp",
    callLabel: "Позвоните нам:",
    toTop: "Наверх",
  },

  home: {
    eyebrow: "Амбулаторная служба ухода · Франкфурт-на-Майне",
    h1a: "Чуткий и профессиональный",
    h1b: "уход на дому",
    lead:
      "Для спокойной жизни, даже когда возраст или болезнь требуют ухода. Мы находим для вас время.",
    heroImgAlt: "Сотрудница Nieder-Eschbacher Pflegedienst положила руки на плечи улыбающегося пожилого мужчины; рядом логотип и услуги: базовый уход, медицинский уход, помощь по хозяйству, индивидуальная поддержка",
    badgeTitle: "С душой и без спешки",
    badgeText: "Уход, для которого есть время",
    welcomeQuote:
      "Мы, команда Nieder-Eschbacher Pflegedienst во Франкфурте-на-Майне, рады вашему интересу. День за днём мы работаем для людей, которые нам доверяют, и обеспечиваем качественный уход в привычной обстановке вашего дома. Наши доброжелательные сотрудники находят для вас время.",
    features: [
      {
        icon: "Clock",
        title: "Мы находим время",
        text: "Заботливое отношение без спешки. Мы хотим, чтобы вам было с нами спокойно.",
        to: "about",
        cta: "О нас",
      },
      {
        icon: "HeartHandshake",
        title: "Наши услуги",
        text: "Базовый и медицинский уход, подобранный именно для вас.",
        to: "services",
        cta: "Услуги",
      },
      {
        icon: "Newspaper",
        title: "Новости и вакансии",
        text: "Новости нашей службы и открытые вакансии в сфере ухода.",
        to: "news",
        cta: "Новости",
      },
    ],
    servicesEyebrow: "Наши услуги",
    servicesTitle: "Индивидуальный уход, исходя из ваших потребностей",
    servicesLead:
      "От базового ухода до круглосуточной связи: мы всесторонне поддерживаем вас в привычной домашней обстановке.",
    valuesEyebrow: "Наши ценности",
    valuesTitle: "Уважение, забота и ответственное отношение",
    valuesLead:
      "Уважение, забота и ответственное отношение составляют наши главные принципы. К каждому человеку мы относимся так, как хотели бы, чтобы относились к нам.",
    ctaTitle: "Не знаете, какая степень ухода вам полагается?",
    ctaLead: "Мы с удовольствием проконсультируем вас лично, у нас или у вас дома. Бесплатно и без обязательств.",
  },

  values: [
    { icon: "Heart", label: "Индивидуальный уход" },
    { icon: "BadgeCheck", label: "Дипломированный персонал" },
    { icon: "MessageCircle", label: "Личная консультация" },
    { icon: "ShieldCheck", label: "Ответственное отношение" },
  ],

  services: [
    {
      id: "grundpflege",
      icon: "HandHeart",
      title: "Базовый уход",
      short: "Гигиена, помощь в передвижении и в повседневных делах, спокойно и с достоинством.",
      description:
        "В рамках базового ухода мы бережно помогаем вам во всех ежедневных процедурах, связанных с гигиеной и подвижностью. Мы не торопимся и всегда уважаем ваше достоинство и право решать самостоятельно.",
      points: [
        "Гигиенический уход (умывание, ванна, душ)",
        "Помощь в передвижении и смена положения",
        "Уход при недержании",
        "Помощь при приёме пищи",
        "Помощь при одевании и раздевании",
      ],
    },
    {
      id: "behandlungspflege",
      icon: "Stethoscope",
      title: "Медицинский уход",
      short: "Медицинские процедуры по назначению врача, надёжно и профессионально.",
      description:
        "Медицинский уход включает все необходимые по медицинским показаниям процедуры и всегда выполняется по назначению врача. Наш дипломированный персонал тесно сотрудничает с вашими врачами.",
      points: [
        "Выдача и раскладка лекарств",
        "Инъекции",
        "Надевание и снятие компрессионных чулок",
        "Современная обработка ран",
        "Контроль сахара в крови и давления",
      ],
      note: "Медицинский уход выполняется только по назначению врача.",
    },
    {
      id: "hauswirtschaft",
      icon: "Home",
      title: "Помощь по хозяйству",
      short: "Мы берём на себя домашние дела, чтобы вам было по-настоящему уютно дома.",
      description:
        "Ухоженный дом во многом определяет самочувствие. Мы помогаем вести хозяйство, чтобы в своих четырёх стенах вы чувствовали себя спокойно и защищённо.",
      points: [
        "Покупки и мелкие поручения",
        "Приготовление еды",
        "Стирка",
        "Уборка квартиры",
      ],
    },
    {
      id: "betreuung",
      icon: "Users",
      title: "Дополнительные услуги сопровождения",
      short: "Совместное время, общение и занятия для большей радости жизни.",
      description:
        "Помимо ухода для нас очень важно человеческое участие. Мы разгружаем ухаживающих родственников и дарим вам время для приятных совместных моментов.",
      points: [
        "Разгрузка ухаживающих родственников",
        "Тренировка ориентации",
        "Общение и компания",
        "Работа с биографией",
      ],
    },
    {
      id: "anleitung",
      icon: "GraduationCap",
      title: "Обучение ухаживающих родственников",
      short: "Мы помогаем вашим близким помогать вам.",
      description:
        "Ухаживающие родственники делают огромное дело. Мы даём практические рекомендации и уверенность в уходе: индивидуально, понятно и у вас дома.",
      points: [
        "Практическое обучение уходу на дому",
        "Консультации по вспомогательным средствам",
        "Советы по организации быта при уходе",
        "Уверенность в вопросах ухода",
      ],
    },
    {
      id: "erreichbarkeit",
      icon: "Clock",
      title: "Круглосуточная связь",
      short: "Мобильный номер доступен круглосуточно, чтобы вы чувствовали себя в безопасности.",
      description:
        "В экстренных случаях мы рядом в любое время дня и ночи. По нашему мобильному экстренному номеру вы дозвонитесь круглосуточно.",
      points: [
        "Мобильный экстренный номер: 0177 / 7202956",
        "Альтернативный номер: 0157 / 36442746",
        "Быстрая помощь в критической ситуации",
        "Безопасность для вас и ваших близких",
      ],
    },
  ],

  servicesPage: {
    eyebrow: "Услуги",
    title: "Всесторонний уход, индивидуально для вас",
    subtitle:
      "Мы предлагаем широкий спектр услуг по уходу и ведению хозяйства, точно подобранный под вашу ситуацию.",
    shortLongTitle: "Краткосрочный и постоянный уход",
    shortLongText:
      "Временно после выписки из больницы или на постоянной основе: мы гибко подстраиваем уход под ваши жизненные обстоятельства, чтобы вы получали именно ту поддержку, которая нужна сейчас.",
    adviceTitle: "Консультации по степеням ухода и страхованию по уходу",
    adviceText:
      "Система ухода сложна. Мы понятно объясняем, какие услуги вам полагаются, и шаг за шагом помогаем с заявлением в кассу страхования по уходу.",
    ctaTitle: "Запросить бесплатную консультацию",
    ctaLead: "Мы с удовольствием проконсультируем вас лично и без обязательств, у нас или у вас дома.",
  },

  about: {
    eyebrow: "О нас",
    title: "Люди, у которых есть для вас время",
    subtitle:
      "Познакомьтесь с нашей командой и нашей философией. Нас отличают время, уважение, забота и настоящая человечность.",
    introTitle: "Ваше благополучие в центре внимания",
    intro: [
      "Наша команда Nieder-Eschbacher Pflegedienst находится во Франкфурте-на-Майне. День за днём мы работаем для людей, которые нам доверяют. Для нас уход значит гораздо больше, чем работа. Это дело сердца.",
      "Наши доброжелательные дипломированные сотрудники осознанно находят для вас время. Хороший уход требует спокойствия, внимания и готовности выслушать, без спешки.",
      "Мы ухаживаем за вами там, где вам лучше всего: у вас дома, в привычной обстановке. Так сохраняются ваша самостоятельность и личное пространство.",
    ],
    teamImgAlt: "Сотрудница службы ухода бережно держит за руки пожилую женщину в инвалидном кресле (иллюстративное фото)",
    valuesTitle: "Ценности, которыми мы руководствуемся",
    valuesLead: "Уважение, забота и ответственное отношение составляют наши главные принципы.",
    pillars: [
      { icon: "Clock", title: "Время", text: "Мы работаем без спешки и уделяем вам настоящее внимание." },
      { icon: "Heart", title: "Забота", text: "Каждый человек уникален. Наш уход тоже." },
      { icon: "Home", title: "Дом", text: "Уход в привычной обстановке, которая даёт чувство безопасности." },
    ],
    ctaTitle: "Познакомьтесь с нами",
    ctaLead: "Будем рады личной беседе с вами.",
  },

  newsPage: {
    eyebrow: "Новости",
    title: "Новости и вакансии",
    subtitle: "Новости нашей службы ухода и открытые вакансии для всех, кто хотел бы присоединиться к нашей команде.",
    newsTitle: "Новости",
    newsLead: "Актуальная информация о нашей службе ухода.",
    careerEyebrow: "Карьера",
    careerTitle: "Станьте частью нашей команды",
    careerLead:
      "Вы любите свою работу в сфере ухода и хотите работать в душевной команде, у которой есть настоящее время для людей? Тогда мы ждём ваше резюме.",
    applyNow: "Откликнуться",
    applySubject: "Отклик на вакансию: помощник по уходу (м/ж/д)",
    tasks: "Ваши задачи",
    profile: "Ваш профиль",
    offer: "Мы предлагаем",
    interested: "Заинтересовались? Отправьте резюме на",
    orCall: "или позвоните нам по номеру",
    questions: "Есть вопросы? Свяжитесь с нами",
  },

  news: [
    {
      id: "willkommen",
      date: "2026-09-21",
      category: "Новости",
      title: "Добро пожаловать на наш новый сайт",
      excerpt:
        "Мы рады, что теперь можем представить нашу службу ухода и наши услуги и в интернете: наглядно, понятно и всегда доступно.",
      body: "Наша цель: сделать всю важную информацию об уходе на дому легко доступной для вас и ваших близких. По любым вопросам вы можете связаться с нами по телефону или через контактную форму.",
    },
    {
      id: "pflegeberatung",
      date: "2025-10-28",
      category: "Консультации",
      title: "Бесплатная консультация по уходу у нас или у вас дома",
      excerpt:
        "Не уверены, какая степень ухода вам подходит? Мы лично и без обязательств проконсультируем вас по всем вопросам, касающимся страхования по уходу и степеней ухода.",
      body: "Немецкая система ухода сложна. Мы находим время, спокойно объясняем возможности и помогаем с оформлением заявлений на услуги. Просто запишитесь на приём.",
    },
    {
      id: "team-verstaerkung",
      date: "2025-10-05",
      category: "Команда",
      title: "Мы растём и ищем новых коллег",
      excerpt:
        "Наша команда постоянно растёт. Станьте частью душевного коллектива, для которого уход означает время и уважение.",
      body: "Мы предлагаем справедливые условия труда, уважительное отношение и настоящее время для людей, за которыми ухаживаем. Посмотрите наши актуальные вакансии.",
    },
  ],

  jobs: [
    {
      id: "pflegehelfer",
      title: "Помощник по уходу (м/ж/д)",
      type: "Неполная или полная занятость",
      location: "Франкфурт-на-Майне, Нидер-Эшбах",
      intro:
        "Для усиления нашей команды мы ищем помощника по уходу, который наполнит жизнью наши ценности: время, уважение и заботу. Приветствуются и те, кто приходит из другой профессии, но с открытым сердцем.",
      tasks: [
        "Помощь в базовом уходе за нашими клиентами",
        "Помощь в передвижении и в повседневных делах",
        "Сопровождение и человеческое участие",
        "Тесное сотрудничество в команде по уходу",
      ],
      requirements: [
        "Радость от работы с людьми и эмпатия",
        "Надёжность, ответственность и командный дух",
        "Первый опыт в сфере ухода приветствуется (необязательно)",
        "Водительские права категории B приветствуются",
      ],
      offer: [
        "Справедливая и своевременная оплата",
        "Уважительная и душевная команда",
        "Настоящее время для ухода, без спешки",
        "Введение в работу и повышение квалификации",
      ],
    },
  ],

  contact: {
    eyebrow: "Контакты",
    title: "Мы рядом с вами",
    subtitle:
      "Вопросы об уходе, запись на приём или консультация: свяжитесь с нами без обязательств. Будем рады вам помочь.",
    formTitle: "Напишите нам",
    formLead: "Мы ответим вам как можно скорее.",
    name: "Имя и фамилия",
    namePlaceholder: "Ваше имя",
    email: "Электронная почта",
    emailPlaceholder: "imya@primer.de",
    phone: "Телефон",
    phonePlaceholder: "Ваш номер телефона",
    message: "Сообщение",
    messagePlaceholder: "Чем мы можем вам помочь?",
    consentBefore: "Я прочитал(а)",
    consentLink: "политику конфиденциальности",
    consentAfter:
      "и даю согласие на обработку моих данных (включая возможные сведения о здоровье в моём сообщении) для рассмотрения моего запроса. Это согласие я могу отозвать в любое время.",
    submit: "Отправить сообщение",
    sending: "Отправка…",
    subject: "Запрос через сайт",
    errName: "Пожалуйста, укажите ваше имя.",
    errEmail: "Пожалуйста, укажите действительный адрес электронной почты.",
    errMessage: "Пожалуйста, напишите нам короткое сообщение.",
    errConsent: "Пожалуйста, подтвердите согласие с политикой конфиденциальности.",
    toastCheck: "Пожалуйста, проверьте введённые данные.",
    toastSuccess: "Спасибо! Ваше сообщение успешно отправлено.",
    toastError: "Произошла ошибка. Пожалуйста, позвоните нам.",
    successTitle: "Спасибо!",
    successText: "Ваше сообщение передано. Мы свяжемся с вами в ближайшее время.",
    sendAnother: "Отправить ещё одно сообщение",
    reachTitle: "Как с нами связаться",
    address: "Адрес",
    phoneLabel: "Телефон",
    fax: "Факс",
    emergency: "Круглосуточный экстренный номер",
    alternatively: "или",
    emailLabel: "Электронная почта",
    hoursTitle: "Часы работы",
    hours: "С понедельника по пятницу: с 08:00 до 17:00",
    careAndEmergency: "Уход и экстренная связь:",
    aroundTheClock: "круглосуточно",
    mapTitle: "Как нас найти",
    mapIframeTitle: "Расположение Nieder-Eschbacher Pflegedienst на Google Картах",
    mapLoad: "Загрузить карту",
    mapNotice:
      "В целях защиты данных карта Google Maps загружается только после вашего согласия. При этом данные передаются в Google.",
    mapButton: "Загрузить карту и показать адрес",
    mapAlt: "Или открыть в Google Картах",
  },

  reviews: {
    eyebrow: "Отзывы",
    title: "Что говорят родственники и пациенты",
    emptyLead: "Ваш опыт помогает другим семьям во Франкфурте найти подходящую службу ухода.",
    countOn: "отзывов на",
    source: "Публичные отзывы из нашего профиля компании в Google.",
    asOf: "По состоянию на:",
    all: "Все отзывы в Google",
    write: "Написать отзыв",
    on: "на",
    starsLabel: "из 5 звёзд",
  },

  notFound: {
    title: "Страница не найдена",
    subtitle: "Ошибка 404",
    text: "Запрошенная страница не существует или была перемещена.",
    home: "На главную",
  },

  imprint: {
    title: "Выходные данные",
    subtitle: "Сведения согласно § 5 Закона ФРГ о цифровых услугах (DDG)",
    company: "Сведения согласно § 5 DDG",
    country: "Германия",
    representedBy: "Представитель",
    managingDirector: "Управляющий директор",
    contact: "Контакты",
    phone: "Телефон",
    fax: "Факс",
    email: "Электронная почта",
    register: "Запись в торговом реестре",
    registerCourt: "Регистрирующий суд",
    registerNumber: "Регистрационный номер",
    taxNumber: "Налоговый номер",
    licence: "Допуск и надзорный орган",
    licenceText:
      "Допущенная амбулаторная служба ухода на основании договора об обслуживании согласно § 72 Социального кодекса, книга XI (SGB XI), с земельными объединениями касс страхования по уходу земли Гессен.",
    authorityText:
      "Компетентный надзорный орган согласно Закону земли Гессен о сопровождении и услугах по уходу (HGBP):",
    dispute: "Урегулирование потребительских споров",
    disputeText:
      "Мы не готовы и не обязаны участвовать в процедурах урегулирования споров в органе по разрешению потребительских споров (§ 36 VSBG).",
    responsible: "Ответственный за содержание согласно § 18 абз. 2 Государственного договора о СМИ (MStV)",
    credit: "Концепция и техническая реализация",
    liabilityContent: "Ответственность за содержание",
    liabilityContentText:
      "Как поставщик услуг мы несём ответственность за собственное содержание этих страниц в соответствии с общим законодательством. Однако мы не обязаны отслеживать переданную или сохранённую информацию третьих лиц либо выяснять обстоятельства, указывающие на противоправную деятельность (ст. 8 Регламента (ЕС) 2022/2065, Акт о цифровых услугах). Обязанности по удалению или блокировке использования информации в соответствии с общим законодательством остаются в силе. Ответственность в этом отношении возможна только с момента, когда нам стало известно о конкретном нарушении. Как только нам становится известно о таких нарушениях, мы незамедлительно удаляем соответствующее содержание.",
    liabilityLinks: "Ответственность за ссылки",
    liabilityLinksText:
      "Наш сайт содержит ссылки на внешние сайты третьих лиц, на содержание которых мы не можем влиять. Поэтому мы не можем нести ответственность за это стороннее содержание. За содержание сайтов, на которые ведут ссылки, всегда отвечает их поставщик или оператор. На момент размещения ссылок сайты были проверены на возможные нарушения закона; противоправное содержание на тот момент выявлено не было. Постоянный контроль содержания сайтов, на которые ведут ссылки, без конкретных признаков нарушения невозможен. Как только нам становится известно о нарушениях, мы незамедлительно удаляем такие ссылки.",
    copyright: "Авторское право",
    copyrightText:
      "Содержание и произведения, созданные оператором сайта на этих страницах, подпадают под действие немецкого авторского права. Воспроизведение, переработка, распространение и любое использование за пределами, установленными авторским правом, требуют письменного согласия соответствующего автора или создателя. Загрузка и копирование этого сайта разрешены только для частного, некоммерческого использования. Если содержание на этом сайте создано не оператором, авторские права третьих лиц соблюдаются; в частности, содержание третьих лиц помечается как таковое. Если вы тем не менее заметите нарушение авторских прав, просим сообщить нам об этом. Как только нам становится известно о нарушениях, мы незамедлительно удаляем такое содержание.",
  },

  privacy: {
    title: "Политика конфиденциальности",
    subtitle: "Информация об обработке ваших персональных данных согласно GDPR (DSGVO)",
    retention: "шести месяцев",
    lastUpdated: "По состоянию на: октябрь 2026 г.",
    controller: {
      title: "1. Ответственный за обработку данных",
      lead: "Ответственным за обработку данных на этом сайте в понимании Общего регламента по защите данных (GDPR) является:",
      representedBy: "в лице управляющего директора",
      phone: "Телефон",
      fax: "Факс",
      email: "Электронная почта",
    },
    dpo: {
      title: "Уполномоченный по защите данных",
      lead: "С нашим уполномоченным по защите данных можно связаться по адресу:",
    },
    general: {
      title: "2. Общие сведения об обработке данных",
      p: [
        "Мы обрабатываем персональные данные только в той мере, в какой это необходимо для работы сайта и рассмотрения ваших запросов. Правовые основания: ст. 6 абз. 1 п. a GDPR (согласие), ст. 6 абз. 1 п. b GDPR (договор или преддоговорные меры) и ст. 6 абз. 1 п. f GDPR (законный интерес в безопасной и стабильной работе этого сайта).",
        "Этот сайт **не использует cookies**, не сохраняет информацию на вашем устройстве (§ 25 TDDDG) и не применяет сервисы аналитики, отслеживания или рекламы. Шрифты и изображения загружаются с нашего собственного сервера; при открытии страниц данные не передаются сторонним сервисам шрифтов или изображений. Автоматизированное принятие решений, включая профилирование (ст. 22 GDPR), не осуществляется.",
      ],
    },
    hosting: {
      title: "3. Хостинг и лог-файлы сервера",
      ownIntro:
        "Этот сайт работает по нашему поручению силами {operator} на сервере в Германии. Поставщик центра обработки данных и сервера: {provider}.",
      logs: "При каждом посещении обрабатываются технически необходимые данные соединения: IP-адрес, дата и время доступа, запрошенная страница, объём переданных данных, тип и версия браузера, операционная система и ранее посещённая страница (реферер). Эти данные не объединяются с другими источниками и служат исключительно для доставки сайта, его безопасности и анализа ошибок. Правовое основание: ст. 6 абз. 1 п. f GDPR. Лог-файлы сервера хранятся только столько, сколько необходимо для безопасной работы, после чего удаляются или анонимизируются.",
      ownLegal:
        "С оператором и поставщиком центра обработки данных заключены договоры об обработке данных по поручению согласно ст. 28 GDPR. В рамках хостинга передача в третьи страны не осуществляется.",
    },
    form: {
      title: "4. Контактная форма",
      p: [
        "Если вы отправляете нам запрос через контактную форму, мы обрабатываем введённые вами данные (имя, адрес электронной почты, по желанию номер телефона и ваше сообщение) для рассмотрения запроса и возможных уточняющих вопросов. Правовое основание: ст. 6 абз. 1 п. b GDPR (подготовка отношений по уходу) и, если вы сообщаете сведения о здоровье, ваше явное согласие согласно ст. 9 абз. 2 п. a GDPR, которое вы даёте, отмечая поле в форме.",
        "Обязательные поля: имя, адрес электронной почты и сообщение; номер телефона указывается по желанию. Без обязательных данных мы не сможем рассмотреть ваш запрос; в этом случае вы всегда можете позвонить нам. Передача осуществляется в зашифрованном виде (TLS). Ваш запрос хранится исключительно на сервере в Германии, работающем по нашему поручению, и не передаётся третьим лицам. Мы удаляем данные не позднее чем через {retention} после завершения рассмотрения запроса, если отношения по уходу не возникли и этому не препятствуют законные сроки хранения. Вы можете в любое время отозвать согласие с действием на будущее, например по электронной почте на {email}.",
      ],
    },
    emailPhone: {
      title: "5. Связь по электронной почте, телефону или в WhatsApp",
      p: [
        "Если вы обращаетесь к нам по электронной почте или телефону, мы обрабатываем ваши данные для рассмотрения обращения (ст. 6 абз. 1 п. b и f GDPR). Обратите внимание: незашифрованные письма могут быть прочитаны третьими лицами при передаче; для сведений о здоровье мы рекомендуем телефон или личную беседу.",
        "Письма на адрес {email} поступают к нам через службу пересылки: доставку обеспечивает {forwarder}, почтовый ящик находится у {mailbox}. При этом обрабатываются адрес отправителя, тема и содержание вашего письма, а данные передаются в том числе в США. Правовое основание: ст. 6 абз. 1 п. f GDPR. Поэтому, пожалуйста, не отправляйте сведения о здоровье по электронной почте, используйте для этого телефон или личную беседу.",
        "На нашем сайте есть ссылка, по которой вы можете написать нам в WhatsApp. Поставщик: WhatsApp Ireland Limited, 4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Ирландия. Ссылка представляет собой обычный переход: соединение с WhatsApp устанавливается только после нажатия, и тогда ваш номер мобильного телефона и содержание сообщения передаются в WhatsApp. Правовое основание: ст. 6 абз. 1 п. b GDPR. WhatsApp обрабатывает данные и за пределами ЕС; Meta сертифицирована в рамках EU-US Data Privacy Framework. Пожалуйста, не отправляйте через WhatsApp сведения о здоровье, а в экстренных случаях звоните нам.",
      ],
    },
    applications: {
      title: "6. Заявки на вакансии",
      p: [
        "Отклики на наши вакансии направляются нам по электронной почте. Мы обрабатываем ваши документы исключительно для проведения процедуры отбора (ст. 6 абз. 1 п. b GDPR, § 26 BDSG). После завершения процедуры документы удаляются не позднее чем через шесть месяцев, если вы не дали согласие на более длительное хранение и трудовые отношения не возникли.",
      ],
    },
    maps: {
      title: "7. Google Maps (решение в два клика)",
      p: [
        "На странице контактов мы предлагаем карту сервиса Google Maps. Поставщик: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Ирландия. Карта загружается **только после вашего явного нажатия** на «Загрузить карту»; до этого данные в Google не передаются. Нажимая кнопку, вы даёте согласие (ст. 6 абз. 1 п. a GDPR) на обработку компанией Google вашего IP-адреса и данных об использовании и, при необходимости, на их передачу на серверы Google LLC в США; при этом Google может сохранять cookies на вашем устройстве. Google сертифицирована в рамках EU-US Data Privacy Framework и дополнительно применяет стандартные договорные положения. Ваше согласие действует только для текущего просмотра страницы. Подробнее: [policies.google.com/privacy](https://policies.google.com/privacy).",
      ],
    },
    rights: {
      title: "8. Ваши права",
      lead: "В отношении ваших персональных данных вы имеете следующие права:",
      items: [
        "Право на доступ (ст. 15 GDPR)",
        "Право на исправление (ст. 16 GDPR)",
        "Право на удаление (ст. 17 GDPR)",
        "Право на ограничение обработки (ст. 18 GDPR)",
        "Право на переносимость данных (ст. 20 GDPR)",
        "Право на возражение против обработки на основании ст. 6 абз. 1 п. f GDPR (ст. 21 GDPR)",
        "Право отозвать данное согласие с действием на будущее (ст. 7 абз. 3 GDPR)",
      ],
      how: "Для реализации своих прав достаточно сообщения в свободной форме на {email} или по почте на указанный выше адрес.",
    },
    authority: {
      title: "9. Право на подачу жалобы в надзорный орган",
      lead: "Вы имеете право подать жалобу в надзорный орган по защите данных (ст. 77 GDPR). Для нас компетентным является:",
      name: "Уполномоченный земли Гессен по защите данных и свободе информации",
      address: "Gustav-Stresemann-Ring 1, 65189 Wiesbaden, Германия",
      url: "https://datenschutz.hessen.de",
      urlLabel: "datenschutz.hessen.de",
    },
    security: {
      title: "10. Безопасность данных",
      p: [
        "Этот сайт доставляется исключительно по зашифрованному соединению HTTPS (TLS). Мы применяем технические и организационные меры для защиты ваших данных от утраты, манипуляций и несанкционированного доступа и постоянно приводим их в соответствие с современным уровнем техники.",
      ],
    },
    changes: {
      title: "11. Изменения этой политики конфиденциальности",
      p: [
        "Мы обновляем эту политику конфиденциальности при изменении правовой ситуации или нашего сайта. Действует опубликованная здесь версия.",
      ],
    },
  },
};

export default ru;
